import { useState } from "react";
import { hotList, rumorItems } from "@/mocks/guaData";

const HERO_BG =
  "https://readdy.ai/api/search-image?query=Warm%20watermelon%20red%20and%20cream%20abstract%20art%20with%20soft%20flowing%20shapes%2C%20ripe%20red%20melon%20texture%20and%20subtle%20seeds%2C%20gentle%20editorial%20gradient%2C%20bright%20airy%20composition%2C%20no%20text&width=1200&height=900&seq=hero-warm-1&orientation=portrait";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const trendIcon: Record<string, string> = { up: "ri-arrow-up-line text-primary-600", down: "ri-arrow-down-line text-accent-600", flat: "ri-loader-3-line text-secondary-500" };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 pt-10 md:pt-14 pb-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-800">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-500 animate-pulse"></span>
            今日实时跟进中 · 已整理 986 场事件复盘
          </div>
          <h1 className="font-heading mt-6 text-4xl md:text-5xl font-bold leading-[1.15] text-foreground-950">
            一次讲清事件的
            <span className="text-primary-600">来龙去脉</span>，<br className="hidden md:block" />
            看穿整个大瓜
          </h1>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-700 max-w-xl">
            今日看瓜把散落各处的线索，按时间线整理成清晰完整的事件梳理。从关键细节到深度复盘与细节汇总，不再翻论坛看帖，一份档案看懂前因后果。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl">
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-5 py-3">
              <i className="ri-search-line text-lg text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && document.getElementById("channels")?.scrollIntoView({ behavior: "smooth" })}
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                placeholder="搜一搜你想吃透的事件…"
              />
            </div>
            <button
              onClick={() => document.getElementById("channels")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap cursor-pointer rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始看瓜
            </button>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {[
              { num: "986", label: "事件档案" },
              { num: "24h", label: "热点追踪" },
              { num: "128", label: "娱乐瓜田" },
              { num: "全网", label: "信息聚合" },
            ].map((s) => (
              <div key={s.label} className="flex flex-col">
                <span className="font-display text-2xl font-bold text-foreground-950">{s.num}</span>
                <span className="text-xs text-foreground-500">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 lg:pl-2">
          <div className="relative overflow-hidden rounded-3xl">
            <img
              src={HERO_BG}
              alt="今日看瓜暖色西瓜主题视觉背景"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent"></div>
            <div className="relative flex h-[340px] flex-col justify-end p-6">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-flashlight-line"></i> 今日推荐复盘
              </span>
              <h3 className="font-heading mt-3 text-xl font-bold text-background-50 leading-snug">
                一部综艺的换人风波：我们如何用时间线还原真相
              </h3>
              <p className="mt-2 text-sm text-background-100/90">从官宣到回应，关键节点按小时排列，脉络一目了然。</p>
            </div>
          </div>
        </div>
      </div>

      <div id="hot" className="mx-auto w-full max-w-[1200px] px-4 md:px-6 pb-16 scroll-mt-24">
        <div className="rounded-3xl border border-background-200 bg-background-50/60 p-5 md:p-7">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className="ri-fire-line text-xl"></i>
              </span>
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">今日热榜</h2>
                <p className="text-xs text-foreground-500">按热度排序的热点事件时间线速览</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {["全部", "娱乐", "商业", "科技", "文化"].map((t, i) => (
                <button
                  key={t}
                  className={`cursor-pointer rounded-full px-4 py-1.5 text-xs font-medium whitespace-nowrap transition-colors ${
                    i === 0 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
            {hotList.map((item) => (
              <article
                key={item.id}
                className={`group rounded-2xl p-4 transition-colors hover:bg-background-100 cursor-pointer ${
                  item.id === 1 ? "bg-primary-50/80 lg:col-span-2" : "bg-background-100/70"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-display text-2xl font-bold text-primary-500">
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className={`${trendIcon[item.trend]} text-sm`}></i>
                    {item.heat}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-[15px] font-bold leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-700">
                  {item.title}
                </h3>
                {item.id === 1 && <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.summary}</p>}
                <div className="mt-3 flex flex-wrap gap-1.5">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">{item.tag}</span>
                  {item.tags.slice(0, 2).map((tg) => (
                    <span key={tg} className="rounded-md bg-background-200 px-2 py-0.5 text-[11px] text-foreground-500">
                      {tg}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <div className="mt-5 flex flex-col md:flex-row gap-3 rounded-2xl bg-background-100 px-5 py-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-700 whitespace-nowrap">
              <i className="ri-flashlight-fill text-primary-500"></i> 最新进展
            </span>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-3">
              {rumorItems.slice(0, 5).map((r) => (
                <div key={r.id} className="flex flex-col gap-1 cursor-pointer hover:text-primary-700">
                  <span className="line-clamp-2 text-sm text-foreground-800 leading-snug">{r.title}</span>
                  <span className="text-[11px] text-foreground-400">
                    {r.tag} · {r.time}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}